import React from 'react'
import './headerBlog.css';

function HeaderBlog3() {
  return (
      <section id='home' className='section_headerBlog'>
        <div className='container headerBlog_main'>
          {/* <h1>Blog</h1> */}

           <div className='col-lg-6 col-md-12 col-sm-12 headerBlog_wrapper'>
                <div className='headerBlogPage_info'>Published on: May 28, 2025</div>
          <p className='headerBlogPage_info'>Author: Ponos Technology</p>
          <h2 className='headerBlogPage_title'>CryptoCPU: validation & proving made fast, affordable and seamless</h2>

           </div>
         
        </div>
    </section>
  )
}

export default HeaderBlog3
